"use client";

import { useEffect } from "react";
import { trackImpressions } from "@/lib/analytics";

// Observa todos los elementos [data-track-impression] en la página.
// Registra una impresión cuando el elemento lleva al menos 1 segundo
// siendo visible en un 50%. Cada slug se cuenta una sola vez por sesión.
export function ImpressionObserver() {
  useEffect(() => {
    const seen = new Set<string>();
    const pending = new Map<string, ReturnType<typeof setTimeout>>();

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const slug = (entry.target as HTMLElement).dataset.trackImpression;
          if (!slug || seen.has(slug)) continue;

          if (entry.isIntersecting) {
            if (!pending.has(slug)) {
              pending.set(
                slug,
                setTimeout(() => {
                  pending.delete(slug);
                  seen.add(slug);
                  io.unobserve(entry.target);
                  trackImpressions([slug]);
                }, 1000),
              );
            }
          } else {
            const t = pending.get(slug);
            if (t !== undefined) {
              clearTimeout(t);
              pending.delete(slug);
            }
          }
        }
      },
      { threshold: 0.5 },
    );

    const attachNew = () => {
      document
        .querySelectorAll<HTMLElement>("[data-track-impression]")
        .forEach((el) => {
          const slug = el.dataset.trackImpression!;
          if (!seen.has(slug)) io.observe(el);
        });
    };

    attachNew();

    // Detecta tarjetas nuevas cuando el usuario hace "Cargar más"
    const mo = new MutationObserver(attachNew);
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
      pending.forEach(clearTimeout);
    };
  }, []);

  return null;
}
